import { useQuery } from 'react-query';
import { axiosInstance } from '../../libs/axiosConfig';
import type { ApiResponse } from '../types/Response';

export const query = <T>(path: string, shouldLoad = true) => {
	return useQuery({
		queryKey: [path.split('/')], //This needs to be changed
		queryFn: async () => {
			return await axiosInstance
				.get(path)
				.then((res) => res.data as ApiResponse<T>);
		},
		enabled: shouldLoad,
	});
};

async function getImage(path: string) {
	return await axiosInstance
		.get(path, {
			responseType: 'blob',
			headers: {
				'Content-Type': 'image/jpeg',
			},
		})
		.then((res) => new Blob([res.data]));
}

export const queryImage = (path: string, shouldLoad = true) => {
	return useQuery({
		queryKey: [path.split('/')], //This needs to be changed
		queryFn: async () => {
			const data = await getImage(path);

			return data;
		},
		enabled: shouldLoad,
	});
};
